import { useEffect, useState } from "react";

import decoColumns from "./deco-columns";
import size from "lodash/size";
import { toastify } from "@src/utility/helpers/toast";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useCompanies = () => {
    const { platformId } = useParams(); 
    const [data, setData] = useState({
        companies : [],
        pagination: {}
    });
    const [kpi, setKpi] = useState([]);
    const [queryParams, setQueryParams] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        sortBy   : "date",
        sortOrder: "desc"
    });
    const { axiosInstance, cancelAllRequests, loading } = useAxios({ base: "panel", initialLoader: true });
    const { getSearchParams } = useSearchParams();

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        row   : {}
    });

    const handleModal = (row = {}) => {
        setModalConfig({
            isOpen: !modalConfig.isOpen,
            row
        });
    };
    const getKpi  = async  () => {
        const { data: rowData } = await axiosInstance.get(`/kpi-setting/${platformId}`);
        setKpi(rowData); 
    };
    const getCompanies = async () => {
        delete queryParams.tab;
        await getKpi();
        const { data, pagination } = await axiosInstance.get(`/client/${platformId}`, {
            params: {
                ...queryParams,
                page     : getSearchParams("page"),
                limit    : getSearchParams("limit"),
                start    : getSearchParams("start"),
                end      : getSearchParams("end"),
                sortQuery: sortConfig
            }
        });
        setData({
            companies: data,
            pagination
        });

    };

    const handleSelectedRows = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const handleBulkActions = async (action) => {
        if (action === "delete" && size(selectedRows)) {
            await axiosInstance.delete(`/client/${platformId}/delete-many`, {
                data: {
                    ids: selectedRows.map((row) => row._id)
                }
            });
            getCompanies();
        } else {
            toastify({
                title: "Please select at least one row to delete",
                type : "error"
            });
        }

    };

    const handleSort = (column, direction) => {
        const SortingField = column?.sort_by ?? "date";
        let newDirection = direction;

        if (sortConfig.sortBy === SortingField) {
            newDirection = sortConfig.sortOrder === "desc" ? "asc" : "desc";
        }
    
        setSortConfig({
            sortBy   : SortingField,
            sortOrder: newDirection
        });
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getCompanies();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams, sortConfig]); 

    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`client/${platformId}/delete/${row._id}`);
            getCompanies();
        } else {
            handleModal(row);
        }
    };

    return {
        loading,
        data,
        getCompanies,
        setQueryParams,
        handleBulkActions,
        handleSelectedRows,
        columns: decoColumns({ handleRowActions, kpi }),
        modalConfig,
        handleModal,
        kpi,
        getKpi,
        handleSort 
    };
};
export default useCompanies;